import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  grid: {
    width: '100%',
    paddingHorizontal: 15,
  },
});
